(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mattress-add-on"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mattress-add-on')) {
    customElements.define('mattress-add-on', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.items = [];
        this.busy = false;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('.mattress-add-on__trigger');
        this.error = this.querySelector('.mattress-add-on__error');
        this.banner = this.querySelector('.mattress-add-on__banner');
        this.selection = this.banner.querySelector('.mattress-add-on__selection');
        this.status = this.banner.querySelector('.mattress-add-on__status');
        this.inlineError = this.banner.querySelector('.mattress-add-on__inline-error');
        this.cartRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const root = this.closest('.product__info-container') || this.closest('product-info') || this.parentElement;
        const placeBanner = () => {
          const form = document.getElementById(this.dataset.productFormId);
          const submit = form && form.querySelector('[name="add"][type="submit"]');
          if (!submit) return;
          if (submit.previousElementSibling !== this.banner) submit.before(this.banner);
          this.banner.hidden = false;
        };
        this.placementObserver = new MutationObserver(placeBanner);
        this.placementObserver.observe(root, { childList: true, subtree: true });
        placeBanner();
        this.trigger.addEventListener('click', () => this.openDialog());
        this.querySelector('.mattress-add-on__close').addEventListener('click', () => this.closeDialog());
        this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.closeDialog(); });
        this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.closeDialog(); });
        this.cards = [...this.querySelectorAll('.mattress-add-on__card')];
        this.querySelector('input[type="search"]').addEventListener('input', (event) => {
          const term = event.target.value.trim().toLowerCase();
          this.cards.forEach((card) => { card.hidden = !card.dataset.search.includes(term); });
          this.querySelector('.mattress-add-on__empty').hidden = this.cards.some((card) => !card.hidden);
        });
        this.cards.forEach((form) => {
          form.addEventListener('submit', (event) => this.addMattress(event));
          form.querySelector('select').addEventListener('change', (event) => {
            form.querySelector('.mattress-add-on__price').textContent = event.target.selectedOptions[0].dataset.price;
            this.updateButtons();
          });
        });
        this.selection.addEventListener('click', (event) => {
          const button = event.target.closest('[data-remove-key]');
          if (button) this.removeMattress(button.dataset.removeKey);
        });
        this.onCartChange = () => this.syncCart().catch(() => {});
        window.addEventListener('pageshow', this.onCartChange);
        this.onVisibility = () => { if (document.visibilityState === 'visible') this.onCartChange(); };
        document.addEventListener('visibilitychange', this.onVisibility);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartChange);
        }
        this.onCartChange();
      }

      disconnectedCallback() {
        this.placementObserver?.disconnect();
        this.unsubscribeCart?.();
        window.removeEventListener('pageshow', this.onCartChange);
        document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.banner && !this.contains(this.banner)) this.banner.remove();
        if (this.dialog?.open) document.body.style.overflow = this.previousOverflow || '';
      }

      openDialog() {
        if (this.dialog.open) return;
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.classList.remove('is-closing');
        this.dialog.showModal();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.dialogAnimation = this.dialog.animate(
          [{ transform: 'translateX(100%)', opacity: .5 }, { transform: 'translateX(0)', opacity: 1 }],
          { duration: reduced ? 0 : 320, easing: 'cubic-bezier(.22,1,.36,1)' }
        );
        this.onCartChange();
      }

      async closeDialog() {
        if (!this.dialog.open || this.closing) return;
        this.closing = true;
        this.dialogAnimation?.cancel();
        this.dialog.classList.add('is-closing');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const animation = this.dialog.animate(
          [{ transform: 'translateX(0)', opacity: 1 }, { transform: 'translateX(100%)', opacity: .5 }],
          { duration: reduced ? 0 : 220, easing: 'ease-in' }
        );
        await animation.finished.catch(() => {});
        this.dialog.close();
        this.dialog.classList.remove('is-closing');
        document.body.style.overflow = this.previousOverflow || '';
        this.closing = false;
      }

      async request(path, options = {}) {
        const response = await fetch(this.cartRoot + path, {
          credentials: 'same-origin',
          ...options,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', ...options.headers }
        });
        let result;
        try { result = JSON.parse(await response.text()); } catch { throw new Error(this.dataset.error); }
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
        return result;
      }

      setCartState(cart) {
        this.currency = cart.currency;
        this.items = cart.items.filter((item) => String(item.properties?._mattress_addon) === this.dataset.productId);
        this.renderSelection();
        this.updateButtons();
      }

      async syncCart() {
        const version = this.syncVersion = (this.syncVersion || 0) + 1;
        const cart = await this.request('cart.js', { cache: 'no-store' });
        if (version === this.syncVersion && this.isConnected) this.setCartState(cart);
      }

      renderSelection() {
        this.selection.replaceChildren();
        this.selection.hidden = this.items.length === 0;
        this.items.forEach((item) => {
          const row = document.createElement('div');
          row.className = 'mattress-add-on__selected-item';
          const imageUrl = item.featured_image?.url || item.image;
          if (imageUrl) {
            const image = document.createElement('img');
            image.className = 'mattress-add-on__selected-image';
            image.src = imageUrl;
            image.alt = item.product_title;
            row.append(image);
          }
          const details = document.createElement('div');
          details.className = 'mattress-add-on__selected-details';
          const fields = [
            ['label', this.dataset.selected],
            ['name', item.product_title],
            ['variant', item.variant_title === 'Default Title' ? '' : item.variant_title],
            ['price', new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: this.currency || 'GBP' }).format(item.final_price / 100) + (item.quantity > 1 ? ' × ' + item.quantity : '')]
          ];
          fields.forEach(([name, value]) => {
            if (!value) return;
            const text = document.createElement('span');
            text.className = 'mattress-add-on__selected-' + name;
            text.textContent = value;
            details.append(text);
          });
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'mattress-add-on__remove';
          remove.dataset.removeKey = item.key;
          remove.textContent = this.dataset.remove;
          remove.disabled = this.busy;
          details.append(remove);
          row.append(details);
          this.selection.append(row);
        });
      }

      updateButtons() {
        this.cards.forEach((form) => {
          const chosen = form.querySelector('select').value;
          const added = this.items.some((item) => String(item.variant_id) === chosen);
          const button = form.querySelector('[type="submit"]');
          button.disabled = this.busy || added;
          button.textContent = added ? this.dataset.added : this.dataset.add;
        });
        this.selection.querySelectorAll('button').forEach((button) => { button.disabled = this.busy; });
      }

      sectionIds() {
        const drawer = document.querySelector('cart-drawer');
        return drawer ? drawer.getSectionsToRender().map((section) => section.id) : ['cart-icon-bubble'];
      }

      refreshCartUI(result) {
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer ? drawer.getSectionsToRender() : [{ id: 'cart-icon-bubble' }];
        sections.forEach((section) => {
          const html = result.sections?.[section.id];
          if (!html) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const source = parsed.querySelector(section.selector || '.shopify-section');
          const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (source && target) target.innerHTML = source.innerHTML;
        });
        if (drawer) {
          if (typeof result.item_count === 'number') drawer.classList.toggle('is-empty', result.item_count === 0);
          else drawer.classList.remove('is-empty');
          const overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', () => drawer.close());
        }
      }

      showError(error) {
        this.error.textContent = error.message || this.dataset.error;
        this.error.hidden = false;
        this.inlineError.textContent = this.error.textContent;
        this.inlineError.hidden = false;
      }

      async addMattress(event) {
        event.preventDefault();
        if (this.busy) return;
        const form = event.currentTarget;
        const chosen = form.querySelector('select').value;
        if (this.items.some((item) => String(item.variant_id) === chosen)) return;
        this.busy = true;
        this.error.hidden = this.inlineError.hidden = true;
        this.updateButtons();
        try {
          const data = new FormData(form);
          data.set('properties[_mattress_addon]', this.dataset.productId);
          data.append('sections', this.sectionIds().join(','));
          data.append('sections_url', window.location.pathname);
          const result = await this.request('cart/add.js', { method: 'POST', body: data });
          this.refreshCartUI(result);
          await this.closeDialog();
          this.status.textContent = this.dataset.added;
          await this.syncCart();
        } catch (error) {
          this.showError(error);
        } finally {
          this.busy = false;
          this.updateButtons();
        }
      }

      async removeMattress(key) {
        if (this.busy || !this.items.some((item) => item.key === key)) return;
        this.busy = true;
        this.error.hidden = this.inlineError.hidden = true;
        this.updateButtons();
        try {
          const result = await this.request('cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0, sections: this.sectionIds(), sections_url: window.location.pathname })
          });
          this.syncVersion = (this.syncVersion || 0) + 1;
          this.setCartState(result);
          this.refreshCartUI(result);
          this.status.textContent = '';
        } catch (error) {
          this.showError(error);
          this.onCartChange();
        } finally {
          this.busy = false;
          this.updateButtons();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
